<template>
    <div class="bottom-center" v-if="subtitles">

        <!--    BLACK BAR SUBTITLES-->
        <div class="black-bar" v-if="type === 'black-bar' && showSubtitles">
            {{ subtitles[currentSubtitleIndex].text }}
        </div>

        <!--    SCROLLING UP SUBTITLES FOR AUDIO-->
        <div id="subtitleContainer" class="subtitleContainer text-center" style="margin-top: 5px;" v-if="type === 'scrolling' && showSubtitles">
            <template v-for="(sentence,idx) in sentences">
                <div v-if="sentence !=null && sentence.text.trim() !== ''"
                     :ref="'sentence_'+idx"
                     :class="{'inactive': idx===0 || idx===2, 'active': idx===1, 'faded': idx===3, 'hidden': idx>3}"
                     :key="'sentence_'+idx"
                     style="margin-bottom: 10px; "
                >
                    {{ sentence.text }}
                </div>
                <div v-else
                     :ref="'sentence_'+idx"
                     :key="'sentence_'+idx"
                     style="margin-bottom: 10px; width:100%"
                >
                    <br>
                </div>
            </template>
        </div>
    </div>

</template>

<script>
    export default {
        name: "MediaEvents",
        props: {
            subtitles: {
                type: Array,
                required: false
            },
            events: {
                type: Array,
                required: false
            },
            showSubtitles: {
                type: Boolean,
                default: true
            },
            type: { //black-bar || scrolling
                type: String,
                default: 'black-bar'
            }
        },
        data() {
            return {
                currentSubtitleIndex: 0,
                transition: true,
                sentences: [],
            }
        },
        methods: {
            setCurrentTime(time, action) {

                time = parseFloat(time);

                if (time <= 0) {
                    this.currentSubtitleIndex = 0;
                    return;
                }

                let currentSubtitleIndex = 0;

                currentSubtitleIndex = this.sentences.findIndex((subtitle) => {
                    return subtitle.start != null && subtitle.end != null && subtitle.start <= time && subtitle.end >= time
                });

                //FORCE SCROLL TO CORRECT SUBTITLE
                if (action === 'set-subtitles' && this.type === 'scrolling') {
                    this.scrollToSubtitle(currentSubtitleIndex, true);
                }
                //SHOW THE NEXT ITERATION OF SUBTITLES
                else if (currentSubtitleIndex !== this.currentSubtitleIndex && currentSubtitleIndex > -1 && this.showSubtitles) {

                    if (this.type === 'black-bar')
                        this.currentSubtitleIndex = currentSubtitleIndex;

                    if (this.type === 'scrolling')
                        this.scrollToSubtitle(currentSubtitleIndex);
                    // this.triggerTransition();
                }

                //CHECK IF EVENT SHOULD FIRE
                if (action != null) {

                    if (action === 'pause') {
                        const actionIndex = this.getCurrentEventIndex(time);
                        if (actionIndex > -1) {
                            this.endEvent(true);
                        }
                        return;
                    }

                    if (action === 'skip') {
                        this.resetEvents();
                        return;
                    }

                    if (action === 'play') {
                        const actionIndex = this.getCurrentEventIndex(time);
                        if (actionIndex > -1) {
                            this.startEvent(actionIndex);
                        }
                        return;
                    }

                    return;
                }

                const currentEventIndex = this.getCurrentEventIndex(time);

                //IS IN EVENT BUT THE EVENT HASN'T BEEN STARTED YET
                if (currentEventIndex > -1 && !this._firedEvents.includes(this.events[currentEventIndex])) {
                    this.startEvent(currentEventIndex);
                }

                //IS OUTSIDE EVENT BUT THE EVENT HASN'T BEEN ENDED YET
                if (currentEventIndex < 0 && !this._endedEvents.includes(this.events[currentEventIndex])) {
                    this.endEvent();
                }

            },
            getCurrentEventIndex(time) {
                return this.events.findIndex((event) => {
                    return event.start <= time && time <= event.end
                });
            },
            startEvent(eventIndex) {
                if (eventIndex < 0) return;
                const eventString = this.events[eventIndex].eventstring;

                if (!this._firedEvents.includes(eventString)) {
                    this._firedEvents.push(eventString);
                    this.$emit('eventStarted', eventString);
                    // console.log('eventStarted', eventString);
                }

                if (this._endedEvents.includes(eventString))
                    this._endedEvents.splice(this._endedEvents.indexOf(eventString), 1);
            },
            endEvent(restart) {

                if (!this._firedEvents || this._firedEvents.length < 1) return;

                const lastStartedEvent = this._firedEvents[this._firedEvents.length - 1];

                if (!this._endedEvents.includes(lastStartedEvent)) {
                    this._endedEvents.push(lastStartedEvent);
                    this.$emit('eventEnded', lastStartedEvent);
                    // console.log('eventEnded', lastStartedEvent);
                }

                if (restart && this._firedEvents.includes(lastStartedEvent)) {
                    this._firedEvents.splice(this._firedEvents.indexOf(lastStartedEvent), 1);
                }
            },
            resetEvents() {
                if (this._firedEvents.length > 0 || this._endedEvents.length > 0) {
                    this.$emit('endAllEvents');
                    // console.log('endAllEvents');
                    this._firedEvents = [];
                    this._endedEvents = [];
                }
            },
            scrollToSubtitle(idx, rerender = false) {

                if (!this.showSubtitles) return;

                if (this.sentences == null || this.sentences.length < 1)
                    return;

                let skipped = false;

                if ((+this.currentSubtitleIndex + 1) !== idx) { //the user skipped / jumped subtitles (re-calculate the scroll)
                    skipped = true;
                }

                this.currentSubtitleIndex = idx;

                let el = document.getElementById('subtitleContainer');

                //Add the classes to the next subtitles in line
                if (this.currentSubtitleIndex > 0) {
                    this.$refs['sentence_' + (+this.currentSubtitleIndex - 1)][0].setAttribute('class', 'inactive');
                }

                let elem = this.$refs['sentence_' + this.currentSubtitleIndex];
                if (elem != null && elem.length > 0)
                    elem[0].setAttribute('class', 'active');

                if ((this.currentSubtitleIndex + 2) <= this.sentences.length)
                    this.$refs['sentence_' + (+this.currentSubtitleIndex + 1)][0].setAttribute('class', 'inactive');

                if ((this.currentSubtitleIndex + 3) <= this.sentences.length)
                    this.$refs['sentence_' + (+this.currentSubtitleIndex + 2)][0].setAttribute('class', 'faded');

                if ((this.currentSubtitleIndex + 4) <= this.sentences.length)
                    this.$refs['sentence_' + (+this.currentSubtitleIndex + 3)][0].setAttribute('class', 'hidden');


                if (skipped || rerender || idx < 4) { //the user skipped / jumped subtitles (re-calculate the scroll) or forced to re-render
                    this._scrollHeight = 0;

                    for (let i = 0; i < (this.currentSubtitleIndex - 1); i++) {
                        let elem = this.$refs['sentence_' + i];
                        if (elem != null && elem.length > 0)
                            this._scrollHeight += +elem[0].getBoundingClientRect().height + 10;
                    }

                    //Mark off screen subtitles as hidden
                    for (let i = 0; i < this.sentences.length; i++) {
                        if (i < (this.currentSubtitleIndex - 1) || i > (this.currentSubtitleIndex + 2)) {
                            this.$refs['sentence_' + i][0].setAttribute('class', 'hidden');
                        }
                    }
                } else {
                    this._scrollHeight += +this.$refs['sentence_' + this.currentSubtitleIndex][0].getBoundingClientRect().height + 10;
                }

                el.scrollTo({
                    behavior: 'smooth',
                    top: this._scrollHeight,
                });
            },
        },
        beforeDestroy() {
            this.currentSubtitleIndex = 0;
            this.transition = true;
            this._firedEvents = [];
            this._endedEvents = [];
        },
        mounted() {
            this._firedEvents = [];
            this._endedEvents = [];

            if (this.type === 'scrolling') {
                this.sentences = [{text: '', start: null, end: null}, {text: '', start: null, end: null}, ...this.subtitles, {
                    text: '',
                    start: null,
                    end: null
                }, {text: '', start: null, end: null}];
                this._scrollHeight = 0;
                this.currentSubtitleIndex = 2;
            } else {
                this.sentences = this.subtitles;
            }
        },

    }
</script>

<style scoped>
    .bottom-center {
        /*bottom: 0;*/
        width: 100%;
    }

    .black-bar {
        background: #000;
        color: #ffffff;
        padding: 13px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
    }

    .adjustPositionOnLargeScreen {
        margin-top: -50px;
    }

    .subtitleContainer {
        height: 130px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        overflow-y: auto;  /* Allow vertical scrolling */
        scrollbar-width: none; /* Hide scrollbar in Firefox */
        -ms-overflow-style: none;  /* Hide scrollbar in IE and Edge */
    }

    .subtitleContainer::-webkit-scrollbar {
        display: none;
    }

    .inactive {
        -webkit-filter: blur(1px);
        -moz-filter: blur(1px);
        -o-filter: blur(1px);
        -ms-filter: blur(1px);
        filter: blur(1px);
        font-size: 16px;
        opacity: 0.5;

        transition: 0.3s;
    }

    .active {
        font-weight: normal;
        font-size: 16px;

        transition: 0.3s;
    }

    .faded {
        -webkit-filter: blur(1px);
        -moz-filter: blur(1px);
        -o-filter: blur(1px);
        -ms-filter: blur(1px);
        filter: blur(1px);
        font-size: 16px;
        opacity: 0.2;


        transition: 0.3s;
    }

    .hidden {
        opacity: 0;
        transition: 0.3s;
    }

</style>
